import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../redux/actions/marketstoreCommentActions";
import "./styles/StoreReviews.css";
import { Translate, I18n } from "react-redux-i18n";
import {
  FaPaperPlane,
  FaEllipsisH,
  FaCamera,
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
  FaThumbsUp,
  FaTimes,
  FaCommentDots,
  FaUser,
} from "react-icons/fa";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import MiniLoader from "./MiniLoader";
import { convertToWebp } from "../utils/imageUtils";

class StoreCommentItem extends React.Component {
  state = { menuOpen: false };

  toggleMenu = () => {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  };

  closeMenu = () => {
    this.setState({ menuOpen: false });
  };

  handleMenuAction = (action) => {
    this.closeMenu();
    action();
  };

  render() {
    const { item, user_id, isOwner } = this.props;
    const isUp = item.Like === 1;
    const isDown = item.Like === 0;

    return (
      <article className="store-review-card">
        <header className="store-review-card-header">
          <img
            className="store-review-card-avatar"
            src={item.Avatar}
            alt={item.Name}
          />
          <div className="store-review-card-meta">
            <p className="store-review-card-name">{item.Name}</p>
            <time className="store-review-card-date">{item.CreatedAt}</time>
          </div>
          <div className="store-review-card-menu">
            <button
              type="button"
              className="store-review-card-menu-btn"
              aria-label="Options"
              onClick={this.toggleMenu}
              onBlur={() => setTimeout(this.closeMenu, 150)}
            >
              <FaEllipsisH />
            </button>
            {this.state.menuOpen && (
              <ul className="store-review-card-menu-dropdown">
                <li>
                  <button
                    type="button"
                    onMouseDown={() =>
                      this.handleMenuAction(
                        isOwner ? this.props.onClickRemove : this.props.onClickReport
                      )
                    }
                  >
                    <Translate
                      value={isOwner ? "comment_remove" : "comment_report"}
                    />
                  </button>
                </li>
              </ul>
            )}
          </div>
        </header>

        {item.Text && (
          <div className="store-review-card-body">
            <p className="store-review-card-text">{item.Text}</p>
            {item.HasMedia && (
              <div className="store-review-card-media">
                <img src={item.Media} alt="" />
              </div>
            )}
          </div>
        )}

        {!item.Text && item.HasMedia && (
          <div className="store-review-card-body">
            <div className="store-review-card-media">
              <img src={item.Media} alt="" />
            </div>
          </div>
        )}

        <footer className="store-review-card-footer">
          <div className="store-review-like-bar">
            <button
              type="button"
              className={`store-review-like-btn${isUp ? " is-active-up" : ""}`}
              onClick={this.props.onClickUp}
            >
              {isUp ? <FaThumbsUp /> : <FaRegThumbsUp />}
              <span className="store-review-like-count">{item.CountLike}</span>
            </button>
            <span className="store-review-like-divider" />
            <button
              type="button"
              className={`store-review-like-btn${isDown ? " is-active-down" : ""}`}
              onClick={this.props.onClickDown}
            >
              {isDown ? <FaThumbsDown /> : <FaRegThumbsDown />}
              <span className="store-review-like-count">{item.CountUnlike}</span>
            </button>
          </div>
        </footer>
      </article>
    );
  }
}

class StoreCommentList extends React.Component {
  state = {
    comment_text: "",
    disabled: true,
    image: "",
    file: "",
    hasFile: false,
    loading: false,
  };

  componentDidMount() {
    this.loadComments();
  }

  loadComments = () => {
    if (!this.props.marketstore?.Id) return;

    this.props
      .LoadMarketstoreComment(this.props.token, {
        comment_id: this.props.marketstore.CommentId,
        store_id: this.props.marketstore.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      })
      .then(() => {
        if (this.props.error && this.props.error !== "empty") {
          alertify.warning(I18n.t(this.props.error));
        }
      });
  };

  isLoggedIn = () => JSON.stringify(this.props.user) !== "{}";

  onChangeImage = async (e) => {
    e.preventDefault();
    if (!this.isLoggedIn()) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
      return;
    }
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        file,
        image: reader.result,
        hasFile: true,
        disabled: false,
      });
    };
    reader.readAsDataURL(file);
  };

  removeImage = () => {
    this.setState({
      file: "",
      image: "",
      hasFile: false,
      disabled: this.state.comment_text.length === 0,
    });
  };

  onClickSendComment = async () => {
    if (!this.isLoggedIn()) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
      return;
    }

    if (!this.state.hasFile && this.state.comment_text === "") return;

    this.setState({ loading: true });
    const params = new FormData();
    if (this.state.hasFile) {
      const webpFile = await convertToWebp(this.state.file);
      params.append("image", webpFile);
    }
    if (this.state.comment_text !== "") {
      params.append("comment", this.state.comment_text);
    }
    params.append("store_id", this.props.marketstore.Id);
    if (this.props.marketstore.CommentId) {
      params.append("comment_id", this.props.marketstore.CommentId);
    }
    params.append("id", this.props.user_id);
    params.append("lang", I18n.t("locale"));

    await this.props.AddComment(this.props.token, params).then(() => {
      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
        this.setState({ loading: false });
      } else {
        this.setState({
          comment_text: "",
          image: "",
          file: "",
          hasFile: false,
          disabled: true,
          loading: false,
        });
      }
    });
  };

  onChangeComment = (event) => {
    const comment = event.target.value;
    this.setState({
      comment_text: comment,
      disabled: comment.length === 0 && !this.state.hasFile,
    });
  };

  onClickUp = async (item) => {
    if (!this.isLoggedIn()) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
      return;
    }
    if (item.Like === 1) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: item.Id,
        status: "1",
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    }
  };

  onClickDown = async (item) => {
    if (!this.isLoggedIn()) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
      return;
    }
    if (item.Like === 0) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: item.Id,
        id: this.props.user_id,
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: item.Id,
        status: "'0'",
        id: this.props.user_id,
      });
    }
  };

  onClickReportComment = async (item) => {
    if (!this.isLoggedIn()) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
      return;
    }
    await this.props.ReportComment(this.props.token, {
      comment_id: item.Id,
      id: this.props.user_id,
    });
  };

  onClickRemoveComment = async (item) => {
    if (!this.isLoggedIn()) {
      alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
      return;
    }
    await this.props.RemoveComment(this.props.token, {
      comment_id: item.Id,
      id: this.props.user_id,
    });
  };

  onClickLoadMore = async () => {
    if (!this.props.marketstore?.Id) return;

    try {
      await this.props
        .LoadMarketstoreCommentMore(this.props.token, {
          comment_id: this.props.marketstore.CommentId,
          store_id: this.props.marketstore.Id,
          id: this.props.user_id,
          page_count: this.props.pageCount,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error && this.props.error !== "empty") {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const loggedIn = this.isLoggedIn();
    const reviews = this.props.marketstoreCommentList || [];
    const userAvatar = loggedIn ? this.props.user.avatar : null;

    return (
      <section className="store-reviews">
        <div className="store-reviews-composer">
          {loggedIn ? (
            <div className="store-reviews-composer-inner">
              {userAvatar ? (
                <img
                  className="store-reviews-composer-avatar"
                  src={userAvatar}
                  alt=""
                />
              ) : (
                <div className="store-reviews-composer-avatar store-reviews-composer-avatar--placeholder">
                  <FaUser />
                </div>
              )}
              <div className="store-reviews-composer-field">
                <textarea
                  name="comment_msg"
                  className="store-reviews-composer-textarea"
                  placeholder={I18n.t("comment_placeholder")}
                  value={this.state.comment_text}
                  onChange={this.onChangeComment}
                  disabled={this.state.loading}
                />
                {this.state.hasFile && (
                  <div className="store-reviews-composer-preview">
                    <img src={this.state.image} alt="" />
                    <button
                      type="button"
                      className="store-reviews-composer-preview-remove"
                      onClick={this.removeImage}
                      aria-label="Remove image"
                    >
                      <FaTimes />
                    </button>
                  </div>
                )}
                <div className="store-reviews-composer-actions">
                  <div className="store-reviews-composer-tools">
                    <input
                      type="file"
                      id="store_review_attach"
                      className="store-reviews-attach-input"
                      accept="image/*"
                      onChange={this.onChangeImage}
                    />
                    <label
                      htmlFor="store_review_attach"
                      className="store-reviews-tool-btn"
                      title={I18n.t("comment_placeholder")}
                    >
                      <FaCamera />
                    </label>
                  </div>
                  <button
                    type="button"
                    className="store-reviews-send-btn"
                    disabled={this.state.disabled || this.state.loading}
                    onClick={this.onClickSendComment}
                  >
                    <FaPaperPlane />
                    <Translate value="store_reviews_send" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <p className="store-reviews-login-hint">
              <Translate value="store_reviews_login_hint" />{" "}
              <Link to="/login">{I18n.t("login")}</Link>
            </p>
          )}
        </div>

        <div className="store-reviews-list-header">
          <h3 className="store-reviews-list-title">
            <Translate value="store_wall" />
          </h3>
          {!this.props.loading && reviews.length > 0 && (
            <span className="store-reviews-count">{reviews.length}</span>
          )}
        </div>

        {this.props.loading ? (
          <div className="store-reviews-loading">
            <MiniLoader />
          </div>
        ) : reviews.length === 0 ? (
          <div className="store-reviews-empty">
            <div className="store-reviews-empty-icon">
              <FaCommentDots />
            </div>
            <p className="store-reviews-empty-title">
              <Translate value="store_reviews_empty_title" />
            </p>
            <p className="store-reviews-empty-text">
              <Translate value="store_reviews_empty_text" />
            </p>
          </div>
        ) : (
          <div className="store-reviews-list">
            {this.state.loading && (
              <div className="store-reviews-loading">
                <MiniLoader />
              </div>
            )}
            {reviews.map((item) => (
              <StoreCommentItem
                item={item}
                key={item.Id}
                isOwner={item.UserId?.toString() === this.props.user_id}
                onClickUp={() => this.onClickUp(item)}
                onClickDown={() => this.onClickDown(item)}
                onClickRemove={() => this.onClickRemoveComment(item)}
                onClickReport={() => this.onClickReportComment(item)}
              />
            ))}
          </div>
        )}

        {this.props.pageSize >= 7 &&
          (this.props.loadingMore ? (
            <div className="store-reviews-loading">
              <MiniLoader />
            </div>
          ) : (
            <div className="store-reviews-load-more">
              <button
                type="button"
                className="store-reviews-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    user: reducer.session.auth,
    marketstoreCommentList: reducer.marketstoreComment.list,
    error: reducer.marketstoreComment.error,
    loading: reducer.marketstoreComment.loading,
    loadingMore: reducer.marketstoreComment.loadingMore,
    pageCount: reducer.marketstoreComment.page_count,
    pageSize: reducer.marketstoreComment.page_size,
    marketstore: reducer.marketstore.item,
    lang: reducer.i18n.locale,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMarketstoreComment: (token, params) =>
    dispatch(actions.loadMarketstoreComment({ token, params })),
  LoadMarketstoreCommentMore: (token, params) =>
    dispatch(actions.loadMarketstoreCommentMore({ token, params })),
  AddComment: (token, params) => dispatch(actions.addComment({ token, params })),
  RemoveLike: (token, params) =>
    dispatch(actions.removeLike({ token, params })),
  UpdateLike: (token, params) =>
    dispatch(actions.updateLike({ token, params })),
  ReportComment: (token, params) =>
    dispatch(actions.reportComment({ token, params })),
  RemoveComment: (token, params) =>
    dispatch(actions.removeComment({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreCommentList);
